
(function containerTypeDefinition() {
    'use strict';
    angular.module('Entities')
        .service('adminContainerTypeService', [
            'restUrlBuilder', 'config', 'authExtend', '$injector',
            function containerTypeService(restUrlBuilder, config, authExtend, $injector) {
                var allTypes = authExtend.isInRole('CONFIG ADMIN APPS');
            
                this.getById = function getById(id, detailLevel) {
                    var params = { lod: detailLevel };

                    return restUrlBuilder.one('adminContainerTypes', id)
                        .get({ params: params });

                };


                this.get = function get(name, organizationalUnitId, applicationId) {

                    var params = { Name: name, OrganizationalUnitId: organizationalUnitId, applicationId: applicationId};
                    if (!allTypes) {
                        params.applicationId = config.appId();
                    }
                    
                    return restUrlBuilder.all('adminContainerTypes')
                        .get({ params: params });
                };

                this.getNotInRole = function (roleId) {
                    var params = { NotInRole: roleId, applicationId: allTypes ? undefined : config.appId() };
                    return restUrlBuilder.all('adminContainerTypes')
                        .get({ params: params });
                };

                this.exportToJson = function exportToJson(containerTypeIds) {
                    return restUrlBuilder.all('adminContainerTypes/exportToJson').put(containerTypeIds, { responseType: 'arraybuffer' });
                };

                this.create = function containerTypeCreate(containerType) {
                    if (containerType == null)
                        throw "containerType no puede ser null";

                    // si no tiene el permisos solo puede crear de edr
                    if (!authExtend.isInRole('CONFIG ADMIN APPS')) {
                        containerType.applications = [];
                        containerType.applications.push({ applicationId: config.appId() });
                    }

                    return restUrlBuilder.all('adminContainerTypes')
                      .post(containerType);
                };

                this.modify = function documentTypeModify(documentType, apply) {
                    if (documentType == null)
                        throw "containerType no puede ser null";
                    
                    return restUrlBuilder.all('adminContainerTypes/' + apply).put(documentType);
                };

                this.share = function containerTypeShare(containerTypes) {
                    if (containerTypes == null)
                        throw "containerTypes no puede ser null";

                    return restUrlBuilder.one('adminContainerTypes/share', containerTypes.id).put();
                };

                this.touchContainers = function touchContainers(containerType) {
                    var params = { typeId: containerType };

                    return restUrlBuilder.all('documentContainersBulk/Touch').put(params);
                };

                this.notShare = function containerTypesNotShare(containerTypes) {
                    if (containerTypes == null)
                        throw "containerTypes no puede ser null";

                    return restUrlBuilder.one('adminContainerTypes/notShare', containerTypes.id).put();
                };

                this.getRoleContainerTypes = function getRoleContainerTypes(roleId) {

                    return restUrlBuilder.one('roles', roleId)
                                         .all('adminContainerTypes')
                                         .get();

                };

                this.setRoleContainerTypes = function setRoleContainerTypes(roleId, rolesContainerType) {

                    return restUrlBuilder.all('adminContainerTypes')
                                         .one('roles', roleId)                                         
                                         .put(rolesContainerType);

                };

                this.import = function importContainerType(containerTypes, version, organizationalUnitId) {

                    if (containerTypes === null || containerTypes.size <= 0) {
                        throw "containerTypes no puede ser null";
                    }

                    var $upload = $injector.get('Upload');
                    if ($upload === null)
                        throw "No se pudo instanciar $upload. Verifique que se cargó el script ng-file-upload";

                    return $upload.upload({
                        url: config.apiUrl('/AdminContainerTypes/Import'),
                        method: 'POST',
                        fields: {
                            applicationId: config.appId(),
                            organizationalUnitId: organizationalUnitId,
                            version: version
                        },
                        file: containerTypes,
                        fileFormDataName: 'imageFile'
                    });
                };

            }
        ]);

})();